import { useQuery } from '@tanstack/react-query';
import { useServices } from '@/shared/hooks/use-services';
import type { GetMerchantDetailsRequest } from '@/modules/stores/types/get-merchant-details';

export function useGetMerchantDetails(input: GetMerchantDetailsRequest) {
  const { getMerchantDetails } = useServices();

  return useQuery({
    queryKey: ['merchant-details', input.slug, input.latitude, input.longitude],
    queryFn: () => getMerchantDetails.execute(input),
    enabled: !!input.slug,
    staleTime: 0, // Sempre fresh para garantir status atualizado da loja
    gcTime: 2 * 60 * 1000, // 2 minutos
    retry: (failureCount, error) => {
      // Máximo 1 retry (2 tentativas no total)
      if (failureCount >= 1) return false;

      // Não retry para erro 500
      if (error.message?.includes('500') || error.message?.includes('Internal Server Error')) {
        return false;
      }

      return true;
    },
    retryDelay: 3000, // 3 segundos entre tentativas
    refetchOnWindowFocus: true, // Refetch quando usuário volta para a aba
    refetchOnMount: true, // Sempre refetch ao montar para garantir dados atualizados
    refetchOnReconnect: true, // Refetch ao reconectar para pegar status atual
  });
}
